export class CustodyStructuredProduct {

    constructor ( 
        public symbol: string,
        public ordersAmountInvested: number,
        public orderQuantity: number,
        public maturityDate: Date,
        public operationType: string,
    ){
    } 
}